
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useOrganization = () => {
  const [organizationId, setOrganizationId] = useState<string | undefined>();
  const [organizationName, setOrganizationName] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getCurrentOrganization = async () => {
      try {
        // First try to get the current user
        const { data: { user } } = await supabase.auth.getUser();
        
        if (!user) {
          console.log('No authenticated user found');
          setIsLoading(false);
          return;
        }

        // Get member data by email using the security definer function
        const { data: memberData, error: memberError } = await supabase.rpc(
          'get_member_by_email',
          { member_email: user.email }
        );

        if (memberError) {
          console.error('Error fetching member data:', memberError);
          setIsLoading(false);
          return;
        }

        if (memberData && memberData.length > 0) {
          const member = memberData[0];
          console.log('Member found:', member);
          setOrganizationId(member.organization_id);
          
          // Set session context for RLS
          await supabase.rpc('set_claim', { 
            claim: 'current_member_id', 
            value: member.id 
          });
          
          await supabase.rpc('set_claim', { 
            claim: 'current_organization_id', 
            value: member.organization_id 
          });

          // Get organization name
          const { data: orgData } = await supabase
            .from('organizations')
            .select('name')
            .eq('id', member.organization_id)
            .single();
          
          if (orgData) {
            setOrganizationName(orgData.name);
          }
        } else {
          console.log('No member found for email:', user.email);
        }
      } catch (error) {
        console.error('Error in getCurrentOrganization:', error);
        toast.error('Failed to load organization data');
      } finally {
        setIsLoading(false);
      }
    };

    getCurrentOrganization();
  }, []);

  return {
    organizationId,
    organizationName,
    isLoading
  };
};
